export const API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_PATH_KEY =
  '/organizations/{organizationId}/surveys/campaigns';
export const API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ENROLLED_USERS_REMOVE_PATH_KEY =
  '/organizations/{organizationId}/surveys/campaigns/enrolled-users/remove';
export const API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_INVITATION_TEMPLATES_TEMPLATEID_VERSIONID_PATH_KEY =
  '/organizations/{organizationId}/surveys/campaigns/invitation/templates/{templateId}/{versionId}';
export const API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_RESULTS_STATS_PATH_KEY =
  '/organizations/{organizationId}/surveys/campaigns/results/stats';
export const API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_CAMPAIGNID_RESPONSES_PATH_KEY =
  '/organizations/{organizationId}/surveys/campaigns/{campaignId}/responses';
export const API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_CAMPAIGNID_RESPONSES_LIST_PATH_KEY =
  '/organizations/{organizationId}/surveys/campaigns/{campaignId}/responses/list';
export const API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_CAMPAIGNID_RESPONSES_RESULTS_STATS_PATH_KEY =
  '/organizations/{organizationId}/surveys/campaigns/{campaignId}/responses/results/stats';
export const API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_CAMPAIGNID_RESPONSES_STATS_PATH_KEY =
  '/organizations/{organizationId}/surveys/campaigns/{campaignId}/responses/stats';
export const API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_CAMPAIGNID_RESPONSES_ID_PATH_KEY =
  '/organizations/{organizationId}/surveys/campaigns/{campaignId}/responses/{id}';
export const API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_PATH_KEY =
  '/organizations/{organizationId}/surveys/campaigns/{id}';
export const API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_END_PATH_KEY =
  '/organizations/{organizationId}/surveys/campaigns/{id}/end';
export const API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_NEXT_PATH_KEY =
  '/organizations/{organizationId}/surveys/campaigns/{id}/next';
export const API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_REMINDER_PATH_KEY =
  '/organizations/{organizationId}/surveys/campaigns/{id}/reminder';
export const API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_CAMPAIGNS_ID_VISIBILITY_PATH_KEY =
  '/organizations/{organizationId}/surveys/campaigns/{id}/visibility';
export const API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_USER_NOTCOMPLETED_PATH_KEY =
  '/organizations/{organizationId}/surveys/user/notcompleted';
export const API_ORGANIZATIONS_ORGANIZATIONID_SURVEYS_USERS_PATH_KEY =
  '/organizations/{organizationId}/surveys/users';
export const API_TEMPLATES_PATH_KEY = '/templates';
export const API_TEMPLATES_ID_PATH_KEY = '/templates/{id}';
export const API_TEMPLATES_ID_NEW_VERSION_PATH_KEY = '/templates/{id}/new-version';
export const API_TEMPLATES_ID_SIMULATE_PATH_KEY = '/templates/{id}/simulate';
export const API_TEMPLATES_ID_VERSION_VERSIONID_PATH_KEY = '/templates/{id}/version/{versionId}';
